import { gql, TypedDocumentNode } from "@apollo/client";

import { AwsRegion, QueryScanProviderSchemasArgs, ScanProviderSchema } from "types/generated";

type ScanProviderSchemaDetails = Pick<ScanProviderSchema, "majorVersions"> & {
  configSchema: {
    regions: Array<Pick<AwsRegion, "id" | "location" | "region">>;
  };
};

export const GET_SCAN_PROVIDER_SCHEMA: TypedDocumentNode<
  { scanProviderSchemas: ScanProviderSchemaDetails[] },
  QueryScanProviderSchemasArgs
> = gql`
  query GetScanProviderSchema($provider: ScanProvider) {
    scanProviderSchemas(provider: $provider) {
      majorVersions
      configSchema {
        ... on AWSScanConfigSchema {
          regions {
            id
            location
            region
          }
        }
      }
    }
  }
`;
